import { render } from "./MoveInfoDialog.vue?vue&type=template&id=04241df3&ts=true"
import script from "./MoveInfoDialog.vue?vue&type=script&lang=ts"
export * from "./MoveInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
